import { MDBCheckbox, MDBIcon, MDBTimepicker } from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";

function convertTo24HourFormat(time) {
  const [timePart, modifier] = time.split(" ");
  const [hours, minutes] = timePart.split(":").map(Number);
  let newHours = hours;
  if (modifier === "AM" && newHours === 12) {
    newHours = 0;
  } else if (modifier === "PM" && newHours !== 12) {
    newHours = newHours + 12;
  }
  return newHours * 60 + minutes;
}

const ScheduleWeekDay = (props) => {
  const [timeview, setTimeview] = useState(props.enabled ? true : false);
  const [tfenabled, setTfenabled] = useState(props.tfenabled ? props.tfenabled : false);
  const [fromTime, setFromTime] = useState(props.tfrom || "8:00 AM");
  const [toTime, setToTime] = useState(props.tto || "05:00 PM");
  const [error, setError] = useState("");
  const [onlytyme, setOnlytyme] = useState(props.onlytyme ? true : false);

  useEffect(() => {
    setTimeview(props.enabled);
  }, [props.enabled]);

  useEffect(() => {
    setTfenabled(props.tfenabled ? props.tfenabled : false);
  }, [props.tfenabled]);

  useEffect(() => {
    setFromTime(props.tfrom || "8:00 AM");
  }, [props.tfrom]);

  useEffect(() => {
    setToTime(props.tto || "05:00 PM");
  }, [props.tto]);

  const toggleTimeView = (e) => {
    const newTimeView = !timeview;
    setTimeview(newTimeView);
    if (props.updateback) {
      if (!newTimeView) {
        props.errorFlag({ flag: false, day: props.day });
        setError("");
      } else {
        if (error) {
          props.errorFlag({ flag: true, day: props.day });
        } else {
          props.errorFlag({ flag: false, day: props.day });
        }
      }

      props.updateback({
        tfenabled,
        fromTime,
        toTime,
        value: props.value,
        day: props.day,
        enabled: e.target.checked,
      });
    }
  };

  const toggletf = (e) => {
    setTfenabled(!tfenabled);
    if (props.updateback) {
      if (!tfenabled) {
        props.errorFlag({ flag: false, day: props.day });
        setFromTime("12:00 AM")
        setToTime("11:59 PM")
        setError("");
      } else {
        if (error) {
          props.errorFlag({ flag: true, day: props.day });
        } else {
          props.errorFlag({ flag: false, day: props.day });
          setFromTime("08:00 AM")
          setToTime("05:00 PM")
        }
      }

      props.updateback({
        tfenabled: !tfenabled,
        fromTime: !tfenabled ? "12:00 AM" : "08:00 AM",
        toTime: !tfenabled ? "11:59 PM" : "05:00 PM",
        day: props.day,
        value: props.value,
        enabled: timeview,
      });
    }
  };



  const updateTime = (e, type) => {
    const newTime = e;
    const fromTime24 = convertTo24HourFormat(fromTime);
    const toTime24 = convertTo24HourFormat(toTime);
    const newTime24 = convertTo24HourFormat(newTime);

    if (type === "from") {
      setFromTime(newTime);
      if (newTime24 > toTime24) {
        setError("From time cannot be greater than to time.");
        props.errorFlag({ flag: true, day: props.day });
        return;
      } else if (newTime24 === toTime24) {
        setError("From time and to time can't be the same.");
        props.errorFlag({ flag: true, day: props.day });
        return;
      } else {
        setError(""); // Clear error
        props.errorFlag({ flag: false, day: props.day });
        // setFromTime(newTime);
        props.updateback({
          tfenabled,
          fromTime: newTime,
          toTime: tfenabled ? "11:59 PM" : toTime,
          value: props.value,
          day: props.day,
          enabled: timeview,
        });
      }
    } else if (type === "to") {
      setToTime(newTime);
      if (newTime24 < fromTime24) {
        setError("To time cannot be less than from time.");
        props.errorFlag({ flag: true, day: props.day });
        return;
      } else if (newTime24 === fromTime24) {
        setError("To time and from time can't be the same.");
        props.errorFlag({ flag: true, day: props.day });
        return;
      } else {
        setError(""); // Clear error
        props.errorFlag({ flag: false, day: props.day });
        // setToTime(newTime);
        props.updateback({
          tfenabled,
          fromTime: tfenabled ? "12:00 AM" : fromTime,
          value: props.value,
          toTime: newTime,
          day: props.day,
          enabled: timeview,
        });
      }
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center mt-2">
        {!onlytyme &&
          <>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  onChange={toggleTimeView}
                  checked={timeview}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <label className="w-16">{props.day}</label>
          </>
        }


        {timeview && (
          <>
            <label className="w-10">From</label>
            <div className="inputSelectLoc w-115px position-relative">
              <MDBTimepicker
                inline
                inputToggle={true}
                readOnly
                justInput
                inputLabel="Time"
                inputProps={{ readOnly: true }}
                defaultValue={fromTime}
                disabled={tfenabled}
                value={fromTime}
                onChange={(e) => updateTime(e, "from")}
              />

              <MDBIcon far icon="clock" className="custom-clock-icon" size="sm" />
            </div>

            <label className="w-5 ms-2">To</label>
            <div className="inputSelectLoc w-115px position-relative">
              <MDBTimepicker
                inline
                inputToggle={true}
                readOnly
                justInput
                inputProps={{ readOnly: true }}
                inputLabel={"Time"}
                defaultValue={toTime}
                value={toTime}
                disabled={tfenabled}
                onChange={(e) => updateTime(e, "to")}
              />
              <MDBIcon far icon="clock" className="custom-clock-icon" size="sm" />
            </div>

            <div className="check_AddLoc w-10 ms-2">
              <MDBCheckbox
                name="flexCheck"
                value=""
                id={props.day + "flexCheckDefault"}
                label="24 hours"
                checked={tfenabled}
                onChange={toggletf}
              />
            </div>
          </>
        )}
      </div>
      <div className="text-center">
        {timeview && error && <span className="ms-5" style={{ color: "red", marginLeft: "10px" }}>{error}</span>}
      </div>
    </div>
  );
};

export default ScheduleWeekDay;
